import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AppointmentModel } from 'projects/core/src/lib/models/appointment.model';
import { TranslocoService } from '@ngneat/transloco';
import { AppointmentCalendarType, AppointmentDayEvent, AppointmentDayEventType } from 'projects/admin/src/app/partials/data/appointments/appointment-calendar/appointment-calendar.component';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss']
})
export class AppointmentsComponent implements OnInit {

  public setup: { [key: string]: string };
  public days: Array<AppointmentModel> = [];
  public reset: Array<AppointmentModel> = [];
  public loading = true;
  public submitting = false;
  public inEdit = false;

  public AppointmentCalendarType = AppointmentCalendarType;

  constructor(
    private api: ApiService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.api.getAppointmentSetup('specialdays').subscribe({
      next: (result: any) => {
        this.setup = result.data;
        this.reset = [...result.data.days];
        this.setDays(result.data.days);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  public onEdit(): void {
    this.inEdit = true;
  }

  public onCancel(): void {
    this.setDays([...this.reset]);
    this.inEdit = false;
  }

  public onSubmit(): void {
    this.submitting = true;
    const payload = this.days.map((day: AppointmentModel) => {
      return day.getPayloadForSaving();
    });
    this.api.saveAppointments('specialdays', payload).subscribe({
      next: (result: any) => {
        this.reset = [...result.data];
        this.setDays(result.data);
      }
    }).add(() => {
      this.submitting = false;
      this.inEdit = false;
    });
  }

  public onDayChange(event: AppointmentDayEventType): void {
    if (event.event === AppointmentDayEvent.Create) {
      this.days = [...this.days, event.day];
    } else if (event.event === AppointmentDayEvent.Delete) {
      this.days = this.days.filter(day => day.day !== event.day.day);
    }
    this.days.sort((a: AppointmentModel, b: AppointmentModel) => {
      return (a.day > b.day) ? 1 : ((b.day > a.day) ? -1 : 0);
    });
  }

  private setDays(days: Array<any>): void {
    this.days = days.map((day: any) => {
      const appointment = new AppointmentModel().deserialize(day);
      appointment.setTranslocoService(this.transloco);
      return appointment;
    });
  }

}
